import { FormGroupState } from 'ngrx-forms';
import { InvestmentItemModel } from 'src/app/model/investment-item.model';

export interface IInvestmentEditState {
  form: FormGroupState<CurrentInvestmentModel>;
  lastModifiedTime: Date;
  currentStep: number;
  steps: number[];
  currentInfo: CurrentInvestmentModel;
  originalCurrentInfo: CurrentInvestmentModel;
  options: CurrentInvestmentModel;
  isPension: boolean;
  futureModelList: InvestmentItemModel[];
  submitText:string;
  failedPerformanceMessage: string;
  isSimpleSwitch:boolean;
}


export class InvestmentModel {
  memberNumber: string = '';
  firstName: string = '';
  lastName: string = '';
  secondName: string = '';
  taxFileNumber: string = '';
}

export class InvestmentBannersModel {
  currentPageBanners: string[] = [];
  futurePageBanners: string[] = [];
}

export class InvestmentValidationsModel {
  minimumOptionPercentage: number;
}

export class CurrentInvestmentModel {
  current: InvestmentItemModel[] = [];
  future: InvestmentItemModel[] = [];
  currentFuture: InvestmentItemModel[] = [];
  hasPendingCurrentOptions: boolean = false;
  failedPerformanceMessage: string;
  disclaimer: boolean = false;
  investmentCustomWording: {[key:string]:string}
  investmentBanners: InvestmentBannersModel = new InvestmentBannersModel();
  investmentValidations: InvestmentValidationsModel = new InvestmentValidationsModel();
  hiddenFuture: InvestmentItemModel[] = [];
  hiddenCurrent: InvestmentItemModel[] = [];
}
